/**
 * Minimal cookie access.
 *
 * The old frontend pulled in `js-cookie` to read and write a single cookie, so
 * that dependency is not carried over.
 */

export function getCookie(name: string): string | undefined {
  const prefix = `${encodeURIComponent(name)}=`;
  const entry = document.cookie
    .split('; ')
    .find((candidate) => candidate.startsWith(prefix));

  return entry ? decodeURIComponent(entry.slice(prefix.length)) : undefined;
}

export function setCookie(
  name: string,
  value: string,
  { days = 365 }: { days?: number } = {},
): void {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie =
    `${encodeURIComponent(name)}=${encodeURIComponent(value)};` +
    `expires=${expires};path=/;SameSite=Lax`;
}

export const COOKIE_CONSENT = 'cookieConsent';

export function hasCookieConsent(): boolean {
  return Boolean(getCookie(COOKIE_CONSENT));
}
